import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useState } from 'react';
export function useForm() {
  var defaultValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _useState = useState(defaultValues),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var getter = function getter(name) {
    var _state$name;

    if (name == null) {
      throw new Error('Undefined `name` prop found in component. Please, make sure every Input has a `name` field.');
    }

    return (_state$name = state[name]) !== null && _state$name !== void 0 ? _state$name : '';
  };

  var setter = function setter(value, name) {
    if (name == null) {
      throw new Error('Undefined `name` prop found in component. Please, make sure every Input has a `name` field.');
    }

    setState(function (state) {
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, name, value));
    });
  };

  var resetter = function resetter() {
    setState(defaultValues);
  };

  return {
    set: setter,
    get: getter,
    values: state,
    reset: resetter
  };
}